import React from 'react'

import Page from '../../../../components/pdf/Page'
import ClientData from './sections/ClientData'
import Result from './sections/result/Result'
import Header from './Header'

const PdfDocument = () => {
  return (
    <Page>
      <Header />
      <ClientData />
      <Result />
    </Page>
  )
}

export default PdfDocument
